import { ISP_Room } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { LoadingView } from "../../../components";
import { RoomQualitySmall } from './RoomQualitySmall'
import { ValueDisplay } from '../../components/ValueDisplay'
import { themedUseStyletron } from '../../../theme/customTheme'
import { RoomIcon } from './IconRoom';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { TimeSeriesLineChart } from '../../../features/Charts/LineCharts/TimeSeriesLineChart';
import {  useMemo } from 'react';
import { OperationModeIcon } from './OperationModeIcon';
import ActiveLightsPanel from '../../Devices/Light/ActiveLightsPanel';
import { schema as schemaMultistate, SmallPanel as MSSmallPanel } from '../../Devices/MultiState'
import { schema as schemaMultistateSwitch, SmallPanel as MSSwitchSmallPanel } from '../../Devices/MultiStateSwitch'
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';
import OpenWindowPanel from '../../Devices/WindowContact/OpenWindowPanel';
import { schemaTemperature, schemaHumidity, schema as schemaSensorAnalog } from '../../Devices/SensorAnalog/types'
import OpenDoorPanel from '../../Devices/Door/OpenDoorPanel';

export function OverviewPanel(props: ISP_Room) {
    const [, theme] = themedUseStyletron();
    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    const { temperature, humitity, co2, state, stateSW } = useMemo(() => {
        const temperature = children?.find((v: any) => v.schema === schemaTemperature);
        const humitity = children?.find((v: any) => v.schema === schemaHumidity);
        const co2 = children?.find((v: any) => v.schema === schemaSensorAnalog && v.dimension === 'ppm');
        const state = children?.find((v: any) => v.schema === schemaMultistate);
        const stateSW = children?.find((v: any) => v.schema === schemaMultistateSwitch);
        return { temperature, humitity, co2, state, stateSW };
    }, [children]);



    const lines = useMemo(() => {
        var tmp: any[] = [];
        if (temperature) tmp.push({
            label: `${temperature.description}`,
            lineColor: theme.appColors.measurments.temperature,
            objectId: temperature.id,
            resourceGroupId: temperature.resourceGroupId,
            propertyName: 'value',
            currentValue: temperature.value,
            showPoints: false,
            fill: false,
            grace: 1
        });
        if (humitity) tmp.push(
            {
                yScaleId: 'y1',
                label: `${humitity.description}`,
                lineColor: theme.appColors.measurments.humidity,
                objectId: humitity.id,
                resourceGroupId: humitity.resourceGroupId,
                propertyName: 'value',
                currentValue: humitity.value,
                showPoints: false,
                fill: false,
                grace: 0
            }
        );
        if (co2) tmp.push(
            {
                yScaleId: 'y2',
                label: `${co2.description}`,
                lineColor: theme.appColors.measurments.default,
                objectId: co2.id,
                resourceGroupId: co2.resourceGroupId,
                propertyName: 'value',
                currentValue: co2.value,
                showPoints: false,
                fill: false,
                grace: 0
            }
        );
        return tmp;
    }, [temperature, humitity, co2]);


    const actionButtons = props.isHeating || props.isCooling ? <OperationModeIcon {...props} /> : undefined;
    return (
        <OverviewPanelWrapper small={false} includeAlarmsFromChildren  {...props} icon={<RoomIcon usage={props.usage} color={theme.colors.backgroundPrimary}></RoomIcon>}
            actionButtons={actionButtons} >
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <>
                    <HorizontalStackPanel>
                        {state && <MSSmallPanel {...state}></MSSmallPanel>}
                        {stateSW && <MSSwitchSmallPanel {...stateSW}></MSSwitchSmallPanel>}
                    </HorizontalStackPanel>
                    <HorizontalStackPanel $gap={theme.sizing.scale600}>

                        <RoomQualitySmall {...props}></RoomQualitySmall>
                        {temperature &&
                            <ValueDisplay  {...temperature}></ValueDisplay>
                        }
                        {humitity &&
                            <ValueDisplay  {...humitity}></ValueDisplay>
                        }
                        {co2 &&
                            <ValueDisplay  {...co2}></ValueDisplay>
                        }
                    </HorizontalStackPanel>
                    <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>
                    <OpenWindowPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></OpenWindowPanel>
                    <OpenDoorPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></OpenDoorPanel>
                    {temperature &&
                        <TimeSeriesLineChart
                            lines={lines}
                            timespan={7 * 24 * 60}
                            summarizeBy={"1h"} showAverage={false} showLegend={false}></TimeSeriesLineChart>
                    }
                </>
            </LoadingView>
        </OverviewPanelWrapper>
    );
}